
import HttpClientApiKeyTurnos from '../../services/HttpClientApiKeyTurnos';
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { TiposTurnoResponse } from '../../interfaces/turnos/TiposTurnoInterface';
import { UbicacionResponse } from '../../interfaces/turnos/UbicacionInterface';

import { ActualizarTurnoParams, CancelarTurnoResponse, ConcluirTurnoResponse, defaultTurno, TomarTurnoResponse } from '../../interfaces/turnos/TurnoInterface';
import { ActualizarConfiguracionParams, ActualizarConfiguracionResponse, ConsultarConfiguracionParams, ConsultarConfiguracionResponse, defaultConfiguracion, } from '../../interfaces/turnos/UsuarioInterface';

export const ConsultarTiposTurno = ( ) => {

    return new Promise<TiposTurnoResponse>( (resolve, eject) => {      
        
        HttpClientApiKeyTurnos.get('/api_key/v1/consultar_turnos_tipos')
        .then( ( { data } : { data : TiposTurnoResponse }) => {           
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve( { success: false, message: error.message, data: [] } );
        });    
        
    });    

}

export const ConsultarUbicacionesActivas = ( ) => {

    return new Promise<UbicacionResponse>( (resolve, eject) => {
        
        HttpClientApiKeyTurnos.get('/api_key/v1/consultar_ubicaciones')
        .then( ( { data } : { data : UbicacionResponse }) => {           
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve( { success: false, message: error.message, data: [] } );
        });    
        
    });    

}

export const ConsultarConfiguracion = ( params: ConsultarConfiguracionParams ) => {

    return new Promise<ConsultarConfiguracionResponse>( (resolve, eject) => {     
        
        HttpClientApiKeyTurnos.post('/api_key/v1/consultar_configuracion_usuario', params)
        .then( ( { data } : { data : ConsultarConfiguracionResponse }) => {           
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve({ 
                success: false, 
                message: error.message,
                data: { ...defaultConfiguracion },
            });
        });  
        
    });    

}

export const ActualizarConfiguracion = ( params: ActualizarConfiguracionParams ) => {

    return new Promise<ActualizarConfiguracionResponse>( (resolve, eject) => {
        
        HttpClientApiKeyTurnos.post('/api_key/v1/actualizar_usuario', params)
        .then( ( { data } : { data : ActualizarConfiguracionResponse }) => {           
            resolve( data );
        })
        .catch( ( error: AxiosError ) => {
            resolve({ 
                success: false, 
                message: error.message,                
                data: { ...defaultConfiguracion },
            });
        });    
        
    });    

}

export const TomarTurno = () => {
    
    return new Promise<TomarTurnoResponse>( (resolve, eject) => {     

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Turno/TomarTurno', null, token)
            .then( ( { data } : { data : TomarTurnoResponse }) => {           
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { 
                    success: false, 
                    message: error.message, 
                    data: { ...defaultTurno }
                });
            }); 

        }      
                
    });    

}

export const CancelarTurno = ( params : ActualizarTurnoParams ) => {
    
    return new Promise<CancelarTurnoResponse>( (resolve, eject) => {      

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Turno/ActualizarTurnoEstado', params, token )
            .then( ( { data } : { data : CancelarTurnoResponse }) => {           
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { 
                    success: false, 
                    message: error.message, 
                    data: { ...defaultTurno }
                });
            });      
            
        }
                
    });    

}

export const ConcluirTurno = ( params : ActualizarTurnoParams ) => {
    
    return new Promise<ConcluirTurnoResponse>( (resolve, eject) => {  

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Turno/ActualizarTurnoEstado', params, token )
            .then( ( { data } : { data : ConcluirTurnoResponse }) => {           
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { 
                    success: false, 
                    message: error.message, 
                    data: { ...defaultTurno }
                });
            });          
            
        }
                
    });    

}

export const IniciarAtencion = ( params : ActualizarTurnoParams ) => {
    
    return new Promise<ConcluirTurnoResponse>( (resolve, eject) => {  

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Turno/ActualizarTurnoEstado', params, token )
            .then( ( { data } : { data : ConcluirTurnoResponse }) => {           
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { 
                    success: false, 
                    message: error.message, 
                    data: { ...defaultTurno }
                });
            });          
            
        }
                
    });    

}
